import * as styles from './Text.module.scss';

import cn from 'classnames';
import * as React from 'react';
import { WithHTMLAttributes } from 'src/types';

export const TextView = [
  'h1',
  'h2',
  'h3',
  'system',
  'description',
  'note',
  'system_description',
  'main',
  'button',
  'sub_system',
  'sub',
  'name',
  'card_big_title',
  'card_title',
  'card_description',
  'block_title',
  'card_description'
] as const;
export type TextPropView = typeof TextView[number];

export const TextAlign = ['Left', 'Right', 'Center'] as const;
export type TextPropAlign = typeof TextAlign[number];

export const TextElement = ['div', 'label', 'span', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'button'] as const;
export type TextPropElement = typeof TextElement[number];

export const TextWeight = ['400', '500', '700', '800'] as const;
export type TextPropWeight = typeof TextWeight[number];

export const TextColor = ['Grey'] as const;
export type TextPropColor = typeof TextColor[number];

export type TextProps = WithHTMLAttributes<
  {
    color?: TextPropColor;
    ellipsis?: boolean;
    className?: string;
    style?: React.CSSProperties;
    element?: TextPropElement;
    view?: TextPropView;
    inline?: boolean;
    inlineBlock?: boolean;
    weight?: TextPropWeight;
    align?: TextPropAlign;
    children: React.ReactNode;
  },
  HTMLElement
>;

const Text = React.forwardRef<any, TextProps>(
  (
    {
      color,
      element: Element = 'div',
      inlineBlock,
      ellipsis,
      weight,
      view = 'main',
      children,
      inline,
      align,
      className,
      ...props
    },
    ref
  ) => (
    <Element
      ref={ref}
      className={cn(
        className,
        styles.text,
        {
          [styles[`text_weight${weight}`]]: weight,
          [styles[`text_align${align}`]]: align,
          [styles[`text_${view}`]]: view,
          [styles.text_inline]: inline,
          [styles.text_inlineBlock]: inlineBlock,
          [styles.text_elementButton]: Element === 'button',
          [styles[`text_color-${color}`]]: color,
          [styles.text_ellipsis]: ellipsis,
        },
      )}
      {...props}
    >
      {children}
    </Element>
  )
);

Text.displayName = 'Text';

export default React.memo(Text);
